// Benepack OMS · Logo 组件 · 3 variant 适配不同场景
// SSOT: docs/ui/theme.md §4.3 + docs/ui/assets/{logo.svg, logo-light.svg, logo-mark.svg}
//   - sidebar: 深底用 logo-light.svg
//   - card:    浅底用 logo.svg (登录页 / 顶栏白底)
//   - mark:    收起态 / favicon · logo-mark.svg
import logoSrc from '@/assets/logo.svg';
import logoLightSrc from '@/assets/logo-light.svg';
import logoMarkSrc from '@/assets/logo-mark.svg';

export type LogoVariant = 'sidebar' | 'card' | 'mark';

export interface LogoProps {
  variant?: LogoVariant;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const SRC: Record<LogoVariant, string> = {
  sidebar: logoLightSrc,
  card: logoSrc,
  mark: logoMarkSrc,
};

export function Logo({ variant = 'card', height = 32, className, style }: LogoProps) {
  return (
    <img
      src={SRC[variant]}
      alt="Benepack OMS"
      height={height}
      className={className}
      style={{ display: 'block', height, width: 'auto', ...style }}
      draggable={false}
    />
  );
}

export default Logo;
